import React from 'react';
import { ReleasePage } from './ReleasePage';

export const ProductCatalogueReleaseVersion = () => {
    return (
        <ReleasePage 
            title="Product Catalogue - Release Versions"
            jsonUrl="/releases_product_catalogue.json"
            mainReleaseType={["Long Term Support"]}
            subReleaseType="Service Pack"
        />
    );
}

export default ProductCatalogueReleaseVersion;